/**
 * 黄江 on 2017/7/30
 * 描述：
 */
const UtilsMixin = {
    handleCatchError(err) {
        // this.$vux.toast.show({
        //   type: 'text',
        //   text: err.response && err.response.statusText ? err.response.statusText : '未知错误',
        // })
    },
    confirm(param){
        this.$confirm(param.title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            typeof(param.sure)&&param.sure()
        }).catch(() => {
            typeof(param.cancel)&&param.cancel()
        });
    },
    isPhone(arg){
        const reg = /^1([2-9])\d{9}$/
        return reg.test(arg)
    }
}
export default {
    methods: UtilsMixin,
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js